import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "./CertificatePage.css";
import { getPublicCertificates } from "../utils/api";
import { useCart } from "../context/CartContext";
import giftBoxImg from "../assets/images/giftBoxImg.png";
import likeImg from "../assets/images/likeImg.png";
import giftCardMainImg from "../assets/images/giftCardMainImg.png";
import letterImg from "../assets/images/letterImg.png";
import creditCardImg from "../assets/images/creditCardImg.png";
import coinsImg from "../assets/images/coinsImg.png";
import giftBoxCircleImg from "../assets/images/giftBoxCircleImg.png";
import calendarImg from "../assets/images/calendarImg.png";
import attentionSignImg from "../assets/images/attentionSignImg.png";
import SEO from "../components/SEO";
import certImg from "../assets/images/certHeroBanerImg.png"

const RULES = [
  {
    image: creditCardImg,
    text: "Сертифікат можна використати для оплати будь-яких товарів в інтернет-магазині zori.place.",
  },
  { image: giftBoxCircleImg, text: "Сертифікат діє на повну суму номіналу або його частину." },
  { image: calendarImg, text: "Термін дії сертифіката — 6 місяців з дати покупки." },
  {
    image: coinsImg,
    text: "Якщо сума замовлення перевищує номінал сертифіката, різниця доплачується окремо.",
  },
  {
    image: attentionSignImg,
    text: "Сертифікат не підлягає поверненню та обміну на грошові кошти.",
  },
];

const goToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export default function CertificatePage() {
  const [certificates, setCertificates] = useState([]);
  const { addItem } = useCart();

  useEffect(() => {
    getPublicCertificates()
      .then((res) => {
        setCertificates(res.data.data || []);
      })
      .catch(console.error);
  }, []);

  return (
    <div className="cert-page page-enter">
      <SEO
        title="Сертифікати"
        description="Замовте подарунковий сертифікат і здивуйте вашого близького"
        url="https://zori.place/certificate"
      />
      {/* Breadcrumb */}
      <div className="container cert-breadcrumb">
        <Link to="/">Головна</Link>
        <span>›</span>
        <span>Подарунковий сертифікат</span>
      </div>

      {/* Hero */}
      <section className="cert-hero">
  <img
    src={certImg}
    alt="banner"
    fetchpriority="high"
    decoding="async"
    className="cert-hero-bg"
  />
        <div className="container cert-hero-inner">
          <div className="cert-hero-content">
            <div className="cert-hero-tag">✦ Подарунковий</div>
            <h1 className="cert-hero-title">
              Подарунковий
              <br />
              сертифікат
            </h1>
            <p className="cert-hero-desc">
              Ідеальний подарунок для будь-якої нагоди.
              <br />
              Нехай близькі обирають те, що подобається їм.
            </p>
            <div className="cert-hero-badges">
              <div className="cert-badge">
                <img src={giftBoxImg} alt="icon" />
                <span>Фізичний сертифікат у стильному дизайні</span>
              </div>
              <div className="cert-badge">
                <img src={likeImg} alt="icon" />
                <span>Підходить для будь-якого свята та віку</span>
              </div>
            </div>
          </div>
          <div className="cert-hero-visual">
            <div className="cert-cards-stack"></div>
          </div>
        </div>
      </section>

      {/* Denominations */}
      <section className="cert-denominations">
        <div className="container">
          <h2 className="section-title">Доступні номінали</h2>
          <div className="cert-denom-grid">
            {certificates.map((c) => (
              <div key={c.id} className="cert-denom-card">
                <div className="cert-denom-preview">
                  {c.image ? (
                    <img
                      src={`${c.image}`}
                      alt={c.code}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: 16,
                      }}
                    />
                  ) : (
                    <>
                      <p className="cert-denom-label">
                        ПОДАРУНКОВИЙ
                        <br />
                        СЕРТИФІКАТ
                      </p>

                      <p className="cert-denom-val">
                        {Number(c.amount).toLocaleString("uk-UA")}
                        <br />
                        грн
                      </p>

                      <p className="cert-denom-brand">zori.place</p>
                    </>
                  )}
                </div>

                <p className="cert-denom-price">{Number(c.amount).toLocaleString("uk-UA")} грн</p>

                <button
                  className="btn-primary"
                  onClick={async () => {
                    try {
                      await addItem({
                        type: "certificate",
                        id: c.id,
                        name: `Сертифікат ${c.amount} ₴`,
                        unitPrice: c.amount,
                        quantity: 1,
                        certificateId: c.id,
                        images: c.image ? [`${c.image}`] : [],
                      });

                      alert("Сертифікат додано до замовлення!");
                    } catch (e) {
                      console.log(e.response?.data || e);
                      alert(e.response?.data?.message || "Помилка покупки сертифіката");
                    }
                  }}
                >
                  Купити
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="cert-how">
        <div className="container cert-how-inner">
          <div className="cert-how-content">
            <h2>Як це працює?</h2>
            <div className="cert-how-steps">
              {[
                {
                  image: letterImg,
                  text: "Після покупки сертифікат буде відправлений на вказану вами адресу.",
                },
                {
                  image: giftBoxImg,
                  text: "Сертифікат можна використовувати для оплати будь-яких товарів у магазині zori.place.",
                },
                {
                  image: likeImg,
                  text: "Сертифікат не підлягає поверненню та обміну на грошові кошти.",
                },
              ].map((s, i) => (
                <div key={i} className="cert-how-step">
                  <img className="cert-how-icon" src={s.image} alt="іконка переваг суртифікату" />
                  <p>{s.text}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="cert-how-visual">
            <img src={giftCardMainImg} alt="how it works" />
          </div>
        </div>
      </section>

      {/* Rules */}
      <section className="cert-rules">
        <div className="container">
          <h2 className="section-title">Правила використання сертифікату</h2>
          <div className="cert-rules-grid">
            {RULES.map((r, i) => (
              <div key={i} className="cert-rule">
                <img src={r.image} alt="rule icon" />
                <p>{r.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cert-cta">
        <div className="container">
          <h2>Подаруйте радість вибору з подарунковим сертифікатом zori.place</h2>
          <button className="btn-primary" onClick={goToTop}>
            Обрати сертифікат
          </button>
        </div>
      </section>
    </div>
  );
}
